import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';

const AppMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:hover': {
    background: 'transparent'
  },
  '& .MuiTouchRipple-root': {
    display: 'none'
  },
  '&:not(:last-child)': {
    borderBottom: '1px solid #D8D8D8' //${props => props.theme.color.grey[400]};
  },
  padding: '0px',
  margin: theme.spacing(0, 3)
}));

export default AppMenuItem;
